import React from 'react';
import {
  Box,
  Flex,
  Heading,
  IconButton,
  Spacer,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import { MdEdit, MdHistory } from 'react-icons/md';
import { Answer, Question } from '../../types/interviewResultConfirm';
import { QuestionEdit } from './QuestionEdit';
import { InterviewResultQuestion } from './InterviewResultQuestion';
import { InterviewResultHistoryList } from './InterviewResultHistoryList';
import { Paper } from '../../components/atoms/Paper';

type Props = {
  answers: Answer[];
  questions: Question[];
  save: {
    readonly on: () => void;
    readonly off: () => void;
    readonly toggle: () => void;
  };
};

export const InterviewResultQuestions: React.VFC<Props> = ({
  answers,
  questions,
  save,
}) => {
  const {
    isOpen: editIsOpen,
    onOpen: editOnOpen,
    onClose: editOnClose,
  } = useDisclosure();
  const {
    isOpen: historyIsOpen,
    onOpen: historyOnOpen,
    onClose: historyOnClose,
  } = useDisclosure();
  return (
    <Box mx="4">
      <Paper py="4" px="5">
        <Flex mb="3" alignItems="center">
          <Heading size="md" color="gray.600" textAlign="left" mt="1">
            質問と回答
          </Heading>
          <Spacer />
          <Tooltip label="履歴">
            <IconButton
              aria-label="history"
              icon={<MdHistory />}
              size="sm"
              fontSize="xl"
              borderRadius="full"
              borderWidth="1px"
              bg="white"
              onClick={historyOnOpen}
              isDisabled={false}
              mr="3"
            ></IconButton>
          </Tooltip>
          <Tooltip label="編集">
            <IconButton
              aria-label="edit"
              icon={<MdEdit />}
              size="sm"
              fontSize="xl"
              borderRadius="full"
              borderWidth="1px"
              bg="white"
              onClick={editOnOpen}
              isDisabled={false}
            ></IconButton>
          </Tooltip>
        </Flex>
        <Box mt="4" py="3" borderTopWidth="1px">
          {questions ? (
            questions.map((q, idx) => (
              <InterviewResultQuestion
                key={idx}
                question={q}
                answers={answers}
              />
            ))
          ) : (
            <></>
          )}
        </Box>
      </Paper>
      <QuestionEdit isOpen={editIsOpen} onClose={editOnClose} save={save} />
      <InterviewResultHistoryList
        isOpen={historyIsOpen}
        onClose={historyOnClose}
      />
    </Box>
  );
};
